"use client";
import Link from "next/link";
import Modal from "../Modal";
import { useState } from "react";

const FloatingButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <>
      <button
        onClick={handleModalToggle}
        className="fixed bottom-4 left-4 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-gray-200 text-xl text-white shadow-lg transition-all duration-300 hover:scale-110 focus:outline-hidden"
        aria-label="پشتیبانی"
      >
        <svg
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlns="http://www.w3.org/2000/svg"
          stroke="#2A3439"
          fill="#2A3439"
          strokeWidth="0"
          viewBox="0 0 24 24"
          height="1em"
          width="1em"
        >
          <path d="M12 2C6.486 2 2 6.486 2 12v4.143C2 17.167 2.897 18 4 18h1a1 1 0 0 0 1-1v-5.143a1 1 0 0 0-1-1h-.908C4.648 6.987 7.978 4 12 4s7.352 2.987 7.908 6.857H19a1 1 0 0 0-1 1V18c0 1.103-.897 2-2 2h-2v-1h-4v3h6c2.206 0 4-1.794 4-4 1.103 0 2-.833 2-1.857V12c0-5.514-4.486-10-10-10z" />
        </svg>
      </button>
      <Modal
        isOpen={isModalOpen}
        handleModalToggle={handleModalToggle}
        sizeClass="w-96"
        title="پشتیبانی"
        closeOptins={false}
      >
        <div className="flex flex-col items-center justify-center gap-y-6 p-6">
          <div className="flex items-center gap-4">
            <Link
              href="https://t.me/marvellife_commodity"
              className="transform rounded-xl bg-blue-600 px-2 py-1 text-lg text-white transition-all duration-300 hover:scale-105 hover:bg-blue-800"
            >
              پشتیبانی نقره
            </Link>

            <Link
              href="https://t.me/marvellife_book"
              className="transform rounded-xl bg-green-600 px-2 py-1 text-lg text-white transition-all duration-300 hover:scale-105 hover:bg-green-800"
            >
              پشتیبانی کتاب
            </Link>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FloatingButton;
